import { applyMiddleware, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import promise from "redux-promise-middleware";
import { thunk } from "redux-thunk";
import cleanFormValues from "./helpers/redux-clean-form-values";
import makeRootReducer from "./reducers";

export const createAppMiddleware = (environment = process.env.NODE_ENV) => {
  const middleware = [promise, thunk, cleanFormValues];

  if (environment === "development") {
    middleware.push(createLogger());
  }

  return middleware;
};

export default (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = createAppMiddleware();

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];
  if (process.env.NODE_ENV === "development") {
    const devToolsExtension = window.devToolsExtension;
    if (typeof devToolsExtension === "function") {
      enhancers.push(devToolsExtension());
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(makeRootReducer(), initialState, compose(applyMiddleware(...middleware), ...enhancers));
  store.asyncReducers = {};

  if (import.meta.hot) {
    import.meta.hot.accept("./reducers", (module) => {
      store.replaceReducer(module.default(store.asyncReducers));
    });
  }

  return store;
};
